<template>
  <div>
    <div class="outmain heighthv pad_20 bor_rad5 ba_f">
      <div class="ba_f mar_t20">
        <div class="shuju_title mar_b20">
          <div class="shuju_title_text">
            <span>{{ $t('rider.prize.title') }}</span>
          </div>
        </div>
        <div class="flex-bet mar_b20">
          <div class="t_l">
            <el-button type="primary" size="medium" @click="handleEdit(false)">{{ $t('rider.prize.add') }}</el-button>
            <el-button size="medium" @click="handleEdit3">{{ $t('rider.prize.punishSet') }}</el-button>
            <el-button size="medium" @click="handleEdit2">{{ $t('rider.prize.rewardSet') }}</el-button>
          </div>
        </div>
        <el-table v-loading="listLoading" :element-loading-text="loadingText" :data="list" stripe style="width: 100%" @selection-change="setSelectRows">
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column prop="riderId" :label="$t('rider.prize.riderId')"></el-table-column>
          <el-table-column prop="userName" :label="$t('rider.list.name')"></el-table-column>
          <el-table-column prop="type" :label="$t('rider.prize.punishType')">
            <template slot-scope="scope">
              <div v-if="scope.row.type == '1'">{{ $t('rider.prize.reward') }}</div>
              <div v-if="scope.row.type == '2'">{{ $t('rider.prize.punish') }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="item" :label="$t('rider.prize.category')">
            <template slot-scope="scope">
              <div v-if="scope.row.item == '1'">{{ $t('rider.prize.changeBalance') }}</div>
              <div v-if="scope.row.item == '2'">{{ $t('rider.prize.noticeWarn') }}</div>
              <div v-if="scope.row.item == '3'">{{ $t('rider.prize.forbidOrder') }}</div>
              <div v-if="scope.row.item == '4'">{{ $t('rider.prize.freezeAccount') }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="money" :label="$t('rider.prize.amount')"></el-table-column>
          <el-table-column prop="note" :label="$t('rider.prize.reason')"></el-table-column>
          <el-table-column prop="state" :label="$t('common.status')">
            <template slot-scope="scope">
              <div v-if="scope.row.state == '1'">{{ $t('rider.prize.appealing') }}</div>
              <div v-if="scope.row.state == '2'">{{ $t('rider.prize.executing') }}</div>
              <div v-if="scope.row.state == '3'">{{ $t('rider.prize.revoked') }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="createdAt" :label="$t('common.addTime')"></el-table-column>
          <el-table-column :label="$t('common.operation')">
            <template slot-scope="scope">
              <el-button type="text" @click="handleEdit(scope.row.id)">{{ $t('common.view') }}</el-button>
              <el-button type="text" @click="handleDelete(scope.row)">{{ $t('common.delete') }}</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination background layout="prev, pager, next" :total="page.total" :page-size="page.pagesize" :current-page.sync="page.currentPage" @current-change="handleCurrentChange"></el-pagination>
        <edit ref="edit" @fetchData="fetchData"></edit>
        <prizeSet ref="prizeset" @fetchData="fetchData"></prizeSet>
        <punishmentSet ref="punishmentset" @fetchData="fetchData"></punishmentSet>
      </div>
    </div>
  </div>
</template>
<script>
import Edit from './components/prizeedit';
import PrizeSet from './components/prizeset';
import PunishmentSet from './components/punishmentset';
import { sanctionList, sanctionDelete } from '@/api/rider';
export default {
  components: { Edit, PrizeSet, PunishmentSet },
  data() {
    return {
      list: [],
      listLoading: true,
      selectRows: '',
      page: { total: 0, pagesize: 10, currentPage: 1 },
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    setSelectRows(val) {
      this.selectRows = val;
    },
    async fetchData() {
      const { data, count } = await sanctionList({ page: this.page.currentPage });
      this.list = data;
      this.page.total = count;
      this.listLoading = false;
    },
    handleCurrentChange(val) {
      this.page.currentPage = val;
      this.fetchData();
    },
    handleDelete(row) {
      this.$baseConfirm(this.$t('confirm.delete'), null, async () => {
        const { msg } = await sanctionDelete({ id: row.id });
        this.$baseMessage(msg, 'success');
        this.fetchData();
      });
    },
    handleEdit(id) {
      this.$refs.edit.showEdit(id);
    },
    handleEdit2() {
      this.$refs.prizeset.showEdit();
      this.$refs.prizeset.getRiderList();
    },
    handleEdit3() {
      this.$refs.punishmentset.showEdit();
    },
  },
};
</script>
